import { el } from 'redom';

import './index.scss';

const sizeTypes = {
  CONTAIN: 'contain',
  COVER: 'cover'
};

const sizeTypeLabelMap = {
  [sizeTypes.CONTAIN]: 'Contain',
  [sizeTypes.COVER]: 'Cover'
};

class SizeControl {

  constructor(configuration) {

    this.size = configuration.size;
    this.onChange = configuration.onChange;

    this.el = el('.size-control-main', [
      this.renderSizeInputs()
    ]);

  }

  renderSizeInput(size) {

    let cls = '';

    if (size === this.size) {
      cls += ' active';
    }

    const input = el('button.size-control-button', {
      type: 'button',
      class: cls,
      onclick: this.handleSizeInputClick.bind(this, size)
    }, [sizeTypeLabelMap[size]]);

    return input;

  }

  renderSizeInputs() {

    const sizeInputs = [];

    const sizes = [
      sizeTypes.CONTAIN,
      sizeTypes.COVER
    ];

    for (let size of sizes) {

      const sizeInput = this.renderSizeInput(size);

      sizeInputs.push(sizeInput);

    }

    return sizeInputs;

  }

  handleSizeInputClick(size, event) {

    event.preventDefault();
    event.stopPropagation();

    if (size === this.size) {
      return;
    }

    this.activateSize(event.target, size);

  }

  doActivateSize(button, size) {

    const current = this.el.querySelector('.active');

    if (current !== null) {
      current.classList.remove('active');
    }

    if (button !== null && button.classList.contains('active') === false) {
      button.classList.add('active');
    }

    this.size = size;

  }

  activateSize(button, size) {

    this.doActivateSize(button, size);

    this.onChange(size);

  }

  update(configuration) {

    this.size = configuration.size;
    this.onChange = configuration.onChange;

    const button = this.el.querySelector('button.' + this.size);

    this.doActivateSize(button, this.size);

  }

}

export default SizeControl;